import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = () => (
  <Helmet>
    {/* Open Graph */}
    <meta property="og:title" content="Emi & Carlos - Nuestra Boda" />
    <meta property="og:description" content="Una experiencia web diseñada con amor para celebrar la boda de Emi & Carlos." />
    <meta property="og:image" content="https://emiliaycarlos.com/lovable-uploads/fotoemi.jpg" />
    <meta property="og:url" content="https://emiliaycarlos.com/" />
    <meta property="og:type" content="website" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Emi & Carlos - Nuestra Boda" />
    <meta name="twitter:description" content="Una experiencia web diseñada con amor para celebrar la boda de Emi & Carlos." />
    <meta name="twitter:image" content="https://emiliaycarlos.com/lovable-uploads/fotoemi.jpg" />

    {/* Preload opcional */}
    <link rel="preload" as="image" href="https://emiliaycarlos.com/lovable-uploads/fotoemi.jpg" />
  </Helmet>
);

export default MetaTags;
